'use client';

/**
 * §1 row 5 — the browser tab, bookmarks and print header named one firm on
 * every tier. The root layout is a server component with no session and
 * `GET /api/firm/profile` is authenticate-gated, so the firm name cannot be
 * resolved in `generateMetadata`; the static title is the pre-login shell's
 * honest answer and this replaces it once the authenticated profile lands.
 */
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useFirmProfile } from '@/lib/hooks/use-firm-profile';

export function FirmDocumentTitle() {
  const { firmName } = useFirmProfile();
  // Re-assert on every route change: a client navigation re-applies the
  // root layout's static metadata title, and with only `firmName` as a dep
  // this effect never ran again — so deep pages (a case's billing tab,
  // /admin/workload/:userId) were left showing the static title.
  const pathname = usePathname();
  useEffect(() => {
    if (firmName) document.title = firmName;
  }, [firmName, pathname]);
  return null;
}
